// extracted by mini-css-extract-plugin
export default {"seatsCount":"u0HwijySaTIPlYuEf5JM","container":"gf12bH1BEJ3f8OiTNfve","formContainer":"ucEbuvBwfWdDZPakN4PY"};